"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _lib = require("../../lib");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ArcNotification = function ArcNotification(_ref) {
  var message = _ref.message,
    description = _ref.description,
    onClick = _ref.onClick,
    duration = _ref.duration,
    type = _ref.type,
    placement = _ref.placement,
    btn = _ref.btn,
    onClose = _ref.onClose,
    icon = _ref.icon;
  return type ? _lib.notification[type]({
    message: message,
    description: description,
    onClick: onClick && onClick,
    duration: duration,
    placement: placement,
    btn: btn,
    onClose: onClose && onClose,
    icon: icon ? /*#__PURE__*/_react["default"].createElement("img", {
      src: icon
    }) : ''
  }) : _lib.notification.open({
    message: message,
    description: description,
    onClick: onClick && onClick,
    duration: duration,
    placement: placement,
    btn: btn,
    onClose: onClose && onClose,
    icon: icon ? /*#__PURE__*/_react["default"].createElement("img", {
      src: icon
    }) : ''
  });
};
var _default = ArcNotification;
exports["default"] = _default;